import { z } from 'zod';

export const BaseEvent = z.object({
  eventId: z.uuid(),
  occurredAt: z.iso.datetime(),
  type: z.string(),
  payload: z.record(z.string(), z.unknown()),
});
export type BaseEvent = z.infer<typeof BaseEvent>;
